import { getDefaultWeightUnitOfMeasure } from 'src/common/helpers/localized-description-helper';
import { EntryMethod } from '../../common/enumerations/entry-method';
import { IItemInputData } from '../../common/interfaces/IItemInputData';
import { ScannedDataHandler } from '../../devices/scanner-operations';
import { addItemToTransaction } from '../../home-page/business-logic/sale-mode-router';
import {
  getSalesKeypadState,
  resetSalesKeypadState,
} from '../../sales-keypad/business-logic/sales-keypad-operations';
import { recallOrderByCodeEntered } from '../../search-order/business-logic/recall-order';

export const onAddItemDataScanned: ScannedDataHandler = async (
  scannedData: string,
): Promise<void> => {
  return addItemToTransaction(formatScannedData(scannedData));
};

export const onRecallOrderDataScanned: ScannedDataHandler = async (
  scannedData: string,
): Promise<void> => {
  return recallOrderByCodeEntered(formatScannedData(scannedData), false);
};

export const formatScannedData = (scannedData: string): IItemInputData => {
  const { metricValue, isManualWeight, quantityEntered } = getSalesKeypadState();
  const itemInputData: IItemInputData = {
    itemId: scannedData,
    entryMethod: EntryMethod.Scanned,
    quantity: metricValue,
    quantityEntryMethod: quantityEntered ? EntryMethod.Keyed : EntryMethod.Automatic,
  };

  if (isManualWeight) {
    itemInputData.isManualWeight = true;
    itemInputData.unitOfMeasureCode = getDefaultWeightUnitOfMeasure();
  }
  resetSalesKeypadState();
  return itemInputData;
};
